<template>
  <div class="member-portrait-create">
    <div class="create-content">
      <div class="create-title">
        <el-form
          ref="nameForm"
          :model="form"
          :rules="rules"
          class="nameForm"
          label-position="left"
          label-width="70px"
          :hide-required-asterisk="true"
        >
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item prop="name" label="画像名称">
                <el-input
                  v-model.trim="form.name"
                  type="text"
                  placeholder="请输入画像名称"
                  autocomplete="off"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="condition">
        <div class="condition-title">
          <span class="title">请选择条件</span>
          <span class="desc">（最多选择5个条件）</span>
        </div>
        <div class="condition-check">
          <span class="condition-check-title">会员条件：</span>
          <span class="condition-check-title">基础条件：</span>
          <el-checkbox-group 
            v-model="checkedCondition"
            :max="5">
            <el-row class="condition-check-row">
              <el-checkbox label="levelCond">会员等级</el-checkbox>
              <el-checkbox label="pointCond">会员积分</el-checkbox>
              <el-checkbox label="totalGetPointCond">累计获取积分</el-checkbox>
              <el-checkbox label="totalUsePointCond">累计消耗积分</el-checkbox>
              <el-checkbox label="totalOrderAmountCond">累计消费金额</el-checkbox>
              <el-checkbox label="totalOrderCountCond">累计购买次数</el-checkbox>
            </el-row>
            <el-row class="condition-check-row">
              <el-checkbox label="sex">性别</el-checkbox>
              <el-checkbox label="ageCond">年龄</el-checkbox>
              <el-checkbox label="registerTimeCond">注册时间</el-checkbox>
              <el-checkbox label="birthDateCond">会员生日</el-checkbox>
            </el-row>
          </el-checkbox-group>
        </div>
        <div class="condition-value">
          <el-form
            ref="valueForm"
            :model="form"
            class="valueForm"
            label-position="right"
            label-width="100px"
            :hide-required-asterisk="true"
          >
            <el-form-item class="condition-form-item" label="会员等级" v-if="checkedCondition.includes('levelCond')">
              <el-select v-model="form.levelCond.rangeCond">
                <el-option v-for="(optionItem, optionIndex) in typeOption" :label="optionItem.label" :value="optionItem.value" :key="optionIndex"></el-option>
              </el-select>
              <el-select v-model="form.levelCond.begin" placeholder="请选择会员等级">
                <el-option v-for="(optionItem, optionIndex) in levelOption" :label="optionItem.label" :value="optionItem.value" :key="optionIndex"></el-option>
              </el-select>
              <el-select v-if="form.levelCond.rangeCond === 'range'" v-model="form.levelCond.end" placeholder="请选择会员等级">
                <el-option v-for="(optionItem, optionIndex) in levelOption" :label="optionItem.label" :value="optionItem.value" :key="optionIndex"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="condition-form-item" label="会员积分" v-if="checkedCondition.includes('pointCond')">
              <el-select v-model="form.pointCond.rangeCond">
                <el-option v-for="(optionItem, optionIndex) in typeOption" :label="optionItem.label" :value="optionItem.value" :key="optionIndex"></el-option>
              </el-select>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="form.pointCond.begin" placeholder="请输入会员积分"></el-input>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-if="form.pointCond.rangeCond === 'range'" v-model="form.pointCond.end" placeholder="请输入会员积分"></el-input>
            </el-form-item>
            <el-form-item class="condition-form-item" label="累计获取积分" v-if="checkedCondition.includes('totalGetPointCond')">
              <el-select v-model="form.totalGetPointCond.rangeCond">
                <el-option v-for="(optionItem, optionIndex) in typeOption" :label="optionItem.label" :value="optionItem.value" :key="optionIndex"></el-option>
              </el-select>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="form.totalGetPointCond.begin" placeholder="请输入累计获取积分"></el-input>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-if="form.totalGetPointCond.rangeCond === 'range'" v-model="form.totalGetPointCond.end" placeholder="请输入累计获取积分"></el-input>
            </el-form-item>
            <el-form-item class="condition-form-item" label="累计消耗积分" v-if="checkedCondition.includes('totalUsePointCond')">
              <el-select v-model="form.totalUsePointCond.rangeCond">
                <el-option v-for="(optionItem, optionIndex) in typeOption" :label="optionItem.label" :value="optionItem.value" :key="optionIndex"></el-option>
              </el-select>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="form.totalUsePointCond.begin" placeholder="请输入累计消耗积分"></el-input>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-if="form.totalUsePointCond.rangeCond === 'range'" v-model="form.totalUsePointCond.end" placeholder="请输入累计消耗积分"></el-input>
            </el-form-item>
            <el-form-item class="condition-form-item" label="累计消费金额" v-if="checkedCondition.includes('totalOrderAmountCond')">
              <el-select v-model="form.totalOrderAmountCond.rangeCond">
                <el-option v-for="(optionItem, optionIndex) in typeOption" :label="optionItem.label" :value="optionItem.value" :key="optionIndex"></el-option>
              </el-select>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.totalOrderAmountCond.begin" placeholder="请输入消费金额"></el-input>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-if="form.totalOrderAmountCond.rangeCond === 'range'" v-model="form.totalOrderAmountCond.end" placeholder="请输入消费金额"></el-input>
            </el-form-item>
            <el-form-item class="condition-form-item" label="累计购买次数" v-if="checkedCondition.includes('totalOrderCountCond')">
              <el-select v-model="form.totalOrderCountCond.rangeCond">
                <el-option v-for="(optionItem, optionIndex) in typeOption" :label="optionItem.label" :value="optionItem.value" :key="optionIndex"></el-option>
              </el-select>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="form.totalOrderCountCond.begin" placeholder="请输入累计购买次数"></el-input>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-if="form.totalOrderCountCond.rangeCond === 'range'" v-model="form.totalOrderCountCond.end" placeholder="请输入累计购买次数"></el-input>
            </el-form-item>
            <el-form-item class="condition-form-item" label="性别" v-if="checkedCondition.includes('sex')">
              <el-radio-group v-model="form.sex">
                <el-radio label="1">男</el-radio>
                <el-radio label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="condition-form-item" label="年龄" v-if="checkedCondition.includes('ageCond')">
              <el-select v-model="form.ageCond.rangeCond">
                <el-option v-for="(optionItem, optionIndex) in typeOption" :label="optionItem.label" :value="optionItem.value" :key="optionIndex"></el-option>
              </el-select>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="form.ageCond.begin" placeholder="请输入年龄"></el-input>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-if="form.ageCond.rangeCond === 'range'" v-model="form.ageCond.end" placeholder="请输入年龄"></el-input>
            </el-form-item>
            <el-form-item class="condition-form-item" label="注册时间" v-if="checkedCondition.includes('registerTimeCond')">
              <el-select v-model="form.registerTimeCond.rangeCond">
                <el-option v-for="(optionItem, optionIndex) in typeOption" :label="optionItem.label" :value="optionItem.value" :key="optionIndex"></el-option>
              </el-select>
              <el-date-picker
                v-if="form.registerTimeCond.rangeCond !== 'range'"
                v-model="form.registerTimeCond.begin"
                type="date"
                placeholder="请选择注册时间">
              </el-date-picker>
              <el-date-picker
                v-if="form.registerTimeCond.rangeCond === 'range'"
                v-model="form.registerTimeCond.range"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item class="condition-form-item" label="会员生日" v-if="checkedCondition.includes('birthDateCond')">
              <el-select v-model="form.birthDateCond.rangeCond">
                <el-option v-for="(optionItem, optionIndex) in typeOption" :label="optionItem.label" :value="optionItem.value" :key="optionIndex"></el-option>
              </el-select>
              <el-date-picker
                v-if="form.birthDateCond.rangeCond !== 'range'"
                v-model="form.birthDateCond.begin"
                type="date"
                placeholder="请选择会员生日">
              </el-date-picker>
              <el-date-picker
                v-if="form.birthDateCond.rangeCond === 'range'"
                v-model="form.birthDateCond.range"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button type="default" @click="goback">返回</el-button>
      <el-button :loading="loading" type="primary" @click="sumbit">确定</el-button>
    </div>
  </div>
</template>

<script>
import { api_postPortrait, api_getPortrait, api_putPortrait } from '@/api/member'
import { api_getListLevelNoPage } from '@/api/common'
export default {
  name: "vipListDetail",
  components: {
  },
  data() {
    return {
      loading: false,
      form: {
        name: '',
        levelCond: { rangeCond: 'equals', begin: '', end: ''},
        pointCond: { rangeCond: 'equals', begin: '', end: ''},
        totalGetPointCond: { rangeCond: 'equals', begin: '', end: ''},
        totalUsePointCond: { rangeCond: 'equals', begin: '', end: ''},
        sex: '1',
        ageCond: { rangeCond: 'equals', begin: '', end: ''},
        registerTimeCond: { rangeCond: 'equals', begin: '', end: '', range: []},
        birthDateCond: { rangeCond: 'equals', begin: '', end: '', range: []},
        totalOrderAmountCond: { rangeCond: 'equals', begin: '', end: ''},
        totalOrderCountCond: { rangeCond: 'equals', begin: '', end: ''},
      },
      checkedCondition: [],
      rules: {
        name: [
          { required: true, message: '画像名称不能为空', trigger: 'blur' }
        ]
      },
      typeOption: [
        {label: '等于', value: 'equals'},
        {label: '大于', value: 'greater'},
        {label: '大于等于', value: 'greaterAndEquals'},
        {label: '小于', value: 'less'},
        {label: '小于等于', value: 'lessAndEqual'},
        {label: '区间', value: 'range'},
      ],
      levelOption: []
    };
  },
  created () {
    if (this.$route.query.id) {
      this.$route.meta.breadcrumbTitle = '<span class="noblack">会员管理/会员画像<span class="black">/编辑画像</span></span>'
      this.getInfo()
    } else {
      this.$route.meta.breadcrumbTitle = '<span class="noblack">会员管理/会员画像<span class="black">/创建画像</span></span>'
    }
    this.getListLevel()
  },
  methods: {
    // 获取会员等级
    async getListLevel () {
      const data = await api_getListLevelNoPage()
      const list = data.map((item) => {
        let obj = {
          label: item.name,
          value: item.sortIndex + ''
        }
        return obj
      })
      this.levelOption = list
    },
    goback () {
      this.$router.go(-1)
    },
    sumbit () {
      this.$refs.nameForm.validate(async (valid) => {
        if (valid) {
          if(this.checkedCondition.length <=0){
            this.$baseMessage('请选择至少一个条件', 'error')
          }else{
            if(!this.isError()){
              this.loading = true
              try {
                let allKey = Object.keys(this.form)
                for(let i in allKey){
                  let key = allKey[i]
                  if(key != 'name'){
                    if(!this.checkedCondition.includes(key)){
                      this.form[key] = null
                    }
                  }
                }
                this.$route.query.id ? await api_putPortrait({...this.form, id: this.$route.query.id}) : await api_postPortrait({...this.form})
                this.$baseMessage('操作成功', 'success')
                this.loading = false
                this.goback()
              } catch (error) {
                this.loading = false
              }
            }else{
              this.$baseMessage('请完善条件设置', 'error')
            }
          }
        } else {
          return false
        }
      })
    },
    isError () {
      let error = false
      for(let i in this.checkedCondition){
        let key = this.checkedCondition[i]
        if (key !== 'sex') {
          if(this.form[key].rangeCond === 'range'){
            if(key != 'registerTimeCond' && key != 'birthDateCond'){
              if(!this.form[key].begin || !this.form[key].end){
                error = true
              }
            }else{
              if(this.form[key].range.length <= 0){
                error = true
              }else{
                this.form[key].begin = this.$moment(this.form[key].range[0]).format('YYYY-MM-DD')
                this.form[key].end = this.$moment(this.form[key].range[1]).format('YYYY-MM-DD')
              }
            }
          }else{
            if(!this.form[key].begin){
              error = true
            }else{
              if(key == 'registerTimeCond' || key == 'birthDateCond'){
                this.form[key].begin = this.$moment(this.form[key].begin).format('YYYY-MM-DD')
              }
            }
          }
        }
      }
      return error
    },
    async getInfo () {
      const data = await api_getPortrait({id: this.$route.query.id})
      console.log('data: ', data);
      let allKey = Object.keys(data)
      Object.keys(data).forEach(key => {
        this.form[key] = data[key]
      })
      this.checkedCondition = allKey.filter((item) => {
        return item != 'id' && item != 'name'
      })
      if(allKey.includes('birthDateCond')){
        if(this.form.birthDateCond.rangeCond == 'range'){
          // this.form.birthDateCond.range = [this.form.birthDateCond.begin, this.form.birthDateCond.end]
          this.$set(this.form.birthDateCond, 'range', [this.form.birthDateCond.begin, this.form.birthDateCond.end])
        }
      }
      if(allKey.includes('registerTimeCond')){
        if(this.form.registerTimeCond.rangeCond == 'range'){
          // this.form.registerTimeCond.range = [this.form.registerTimeCond.begin, this.form.registerTimeCond.end]
          this.$set(this.form.registerTimeCond, 'range', [this.form.registerTimeCond.begin, this.form.registerTimeCond.end])
        }
      }
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.member-portrait-create {
  padding: 0 30px;
  padding-bottom: 100px;
  .create-content{
    .create-title{
      height: 100px;
      border-bottom: 1px solid #ccc;
      box-sizing: border-box;
      padding-top: 35px;
      ::v-deep {
        .el-input{
          border-radius: 2px;
          width: 400px;
          .el-input__inner{
            background: #F2F3F5;
          }
          .el-input__inner:focus{
            background: #fff;
            border: 1px solid #05C8AF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            background: #fff;
          }
        }
      }
    }
  }
  .condition{
    .condition-title{
      height: 68px;
      line-height: 68px;
      .title{
        font-size: 16px;
        color: #333;
        font-weight: 500;
      }
      .desc{
        font-size: 12px;
        color: #999;
      }
    }
    .condition-check{
      margin-top: 10px;
      margin-left: 104px;
      border-bottom: 1px solid #ccc;
      box-sizing: border-box;
      position: relative;
      .condition-check-title{
        position: absolute;
        top: 2px;
        left: -104px;
        font-size: 14px;
        color: #333;
      }
      .condition-check-title:nth-child(2){
        top: 51px;
      }
      .condition-check-row{
        margin-bottom: 30px;
        .el-checkbox{
          width: 138px;
          margin: 0;
        }
      }
    }
    .condition-value{
      margin-left: 104px;
      margin-top: 30px;
      ::v-deep {
        .el-input{
          border-radius: 2px;
          width: 200px;
          margin-right: 10px;
          .el-input__inner{
            background: #F2F3F5;
          }
          .el-input__inner:focus{
            background: #fff;
            border: 1px solid #05C8AF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            background: #fff;
          }
        }
      }
    }
  }
  .footer{
    position: fixed;
    bottom: 0;
    height: 80px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    padding-left: 70px;
    padding-top: 23px;
    box-sizing: border-box;
    bottom: 0;
    button{
      padding: 0;
      height: 34px;
      text-align: center;
      width: 110px;
      font-size: 16px;
      border: 0;
      line-height: 34px;
    }
  }
}
</style>
